import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw16px = 'M8.464 10.552a.754.754 0 0 1 0 1.06l-2.92 2.92a.674.674 0 0 1-.24.16.684.684 0 0 1-.29.06.772.772 0 0 1-.15-.02.737.737 0 0 1-.38-.2l-2.91-2.92a.737.737 0 0 1 0-1.06.754.754 0 0 1 1.06 0l1.63 1.64V2a.75.75 0 0 1 1.5 0v10.19l1.64-1.64a.754.754 0 0 1 1.06.002ZM10 7.252H8a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5Zm2-3H8a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 0-1.5Zm2-3H8a.75.75 0 0 0 0 1.5h6a.75.75 0 1 0 0-1.5Z';
const draw24px = 'M9.93,17.62,7,20.53a.75.75,0,0,1-.38.21H6.48A.73.73,0,0,1,6,20.53L3,17.62A.75.75,0,0,1,4.1,16.56l1.63,1.63v-15a.75.75,0,0,1,1.5,0v15l1.64-1.63a.75.75,0,0,1,1.06,1.06Zm-3.3,3.12A.72.72,0,0,0,7,20.53.75.75,0,0,1,6.63,20.74ZM21.75,3.84A.75.75,0,0,0,21,3.09H13a.75.75,0,0,0,0,1.5h8A.76.76,0,0,0,21.75,3.84ZM19.46,9.37a.74.74,0,0,0-.75-.75H13a.75.75,0,0,0,0,1.5h5.71A.75.75,0,0,0,19.46,9.37ZM17.18,14.9a.75.75,0,0,0-.75-.75H13a.75.75,0,0,0,0,1.5h3.43A.76.76,0,0,0,17.18,14.9Z';
const icons = {
  _16: {
    d: draw16px,
    viewBox: VIEWBOXES._16
  },
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const SortDownIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'sortDown'));
SortDownIcon.displayName = 'SortDownIcon';
SortDownIcon.propTypes = Icon.propTypes;
SortDownIcon.renderIcon = props => /*#__PURE__*/React.createElement(SortDownIcon, props);
export default SortDownIcon;
//# sourceMappingURL=SortDownIcon.js.map